
/** 正式上 */
let config = {
    baseUrl: 'https://zijin.233bai.cn/api',
    /** 是否执行某个代码 */
    isExecute: false,
    nodeEnv: 'production'
};

/** 开发环境 */
if(process.env.UMI_ENV === 'development') {
    config = {
        // baseUrl: 'http://172.24.134.89:14431/api', // 2.x
        // baseUrl: 'http://172.24.134.89:14432/api', // 3.x
        baseUrl: 'https://zijin-dev.233bai.cn/api', // 3.x
        isExecute: true,
        nodeEnv: 'development'
        // nodeEnv: 'production'
    };
}

if(process.env.UMI_ENV === 'serve') {
    config = {
        baseUrl: 'https://zijin-dev.233bai.cn/api', // 3.x
        isExecute: true,
        nodeEnv: 'production'
    };
}

console.log(config, process.env.UMI_ENV);
export default config;